module.exports = "/_next/static/images/icon-ios-af5814c0.png";